import { get } from "@/api";
import { removeEmptyKeys, isEqual } from "@/functions";
import store from "@/store";
import auth from "@/auth";

const routeName = route => route.name.replace('.mine', '')

/**
 * Helper function
 */
function loadData(route, query) {
    // General route and "mine" route use the same api end-point
    let name = routeName(route);

    query = removeEmptyKeys(query);

    store.commit("SET_ROUTE", { route: name, query });

    if (route.name.includes('mine')) query = { ...query, user: auth.user.id }

    return get(name, query);
}

/**
 * Mixin that handles data loading on a filtered list
 */
export const FilteredListDataMixin = {
    /**
     * Standard data for each filtered-list page
     */
    data() {
        return {
            sort: this.$route.query.sort || "name",
            page: this.$route.query.page || 1,
            filters: {
                // Fill with per page filters
            },
            meta: {
                current_page: "",
                last_page: "",
                total: ""
            }
        }
    },

    /**
     * Load data URL 
     */
    beforeRouteEnter(to, from, next) {
        loadData(to, to.query).then(response =>
            next(vm => vm._setDataFromResponse(response))
        );
    },

    mounted() {
        let route = routeName(this.$route)

        if (store.state.scrollY.route == route) {
            window.scrollTo(0, store.state.scrollY.scrollY)
        }
    },

    beforeRouteLeave(to, from, next) {
        let route = routeName(from)
        let scrollY = window.scrollY

        store.commit('SET_SCROLL_Y', { route, scrollY })
        next()
    },

    /**
     * Watch for changes in any of the filters
     */
    watch: {
        filters: {
            handler() {
                this.page = 1; // Reset page
                this.loadData();
            },
            deep: true
        }
    },

    methods: {
        loadData() {
            let query = removeEmptyKeys({
                ...this.filters,
                sort: this.sort,
                page: this.page
            });

            if (!isEqual(query, this.$route.query)) this.$router.replace({ query });

            loadData(this.$route, query).then(response => this._setDataFromResponse(response));
        },

        /**
         * Internal function do not override
         */
        _setDataFromResponse(response) {
            let { current_page, last_page, total } = response.data;
            this.meta = { current_page, last_page, total };
            // Pass response data on to actual page component
            this.setData(response.data);
        },

        setPage(page) {
            this.page = page;
            this.loadData();
        },

        setSort(sort) {
            this.sort = sort;
            this.loadData();
        },

        /**
         * Reset all filters to an empty string
         */
        clearFilters() {
            Object.keys(this.filters).forEach(key => (this.filters[key] = ""));
        },
    }
}